import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { ClientAccountService } from '../client-accounts/client-account.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserAuditV2Service } from 'src/app/reports/user-audit-updated/user-audit-v2.service';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit, OnDestroy {

  type: string;
  // subscription: Subscription;
  minOptions: any[];
  recalcChoice: number;
  countMin: number;

  stringValue: string;

  deleteConfirmation = ['SMPP account', 'Account', 'Authorized IP', 'accountDelEMail', 'DeletePolicy', 'deleteFilterConfirmation',
  'DeletePolicies', 'DeleteFilters', 'DeleteFilter', 'DeleteTrafficBlocker', 'DeleteTrafficBlockers', 'DeleteStoplossTrigger',
  'DeleteStoplossTriggers', 'DeleteRoutingRule', 'Provider SMPP account', 'ProviderProfileRoutesDelete', 'deleteEmailSchedules',
  'deleteExistingRuleBeforeSavingNew', 'removeSelectedSIDs', 'removeALLSIDs', 'removeSelectedContentMasks', 'DeleteInvoiceSettings',
  'deleteSetting', 'deleteHLROverrides', 'deleteVIPListItem', 'DeleteRoutingRules','removeActivePolicies', 'DeleteTradingRules',
  'DeleteInvoiceVerificationReport', 'deletePrefixesItem', 'deleteDestPrefixes','RemoveDlrPolicy','removeDlrUndelMcc'];
  applyConfirmation = ['Apply Costs', 'SidPolicies', 'RatesRecalculation', 'UpdateActivity', 'Account Test Mode',
  'ProviderCostsUpdateActivity',
  'UpdateRoutingProfileActivity', 'ClientXeroCheck', 'routingRulesActivation', 'saveRoutingRuleNoConditions', 'SaveFilterConfirmation',
  'saveRoutingRuleNoMCC', 'saveRoutingRuleNoClientId', 'removeVIPNumberReason', 'addNVIPNumberReason', 'changeVIPNumberReason',
  'deletingSMPPAccounts', 'changeTradingRules'];

  constructor(@Inject(MAT_DIALOG_DATA) public data, public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
              private clientAccountService: ClientAccountService,
              private userAuditV2Service: UserAuditV2Service) {
  }

  ngOnInit() {
    this.type = this.data.type;

    if (this.type === 'RatesRecalculation') {
      this.data.getAllData.then((res) => {
        this.data.loadingData = res.loadingData;
        this.data.count       = res.count;
        this.countMin = this.data.allData.filter((item: any) => item.min_optimize_prcn == null || item.min_optimize_prcn === 0).length;

        this.recalcChoice     = 0;
        this.minOptions       = [{
          value: 0,
          text: 'All selected rates (' + this.data.count + ')'
        }, {
          value: 1,
          text: 'All selected rates with MIN is empty or 0%  (' + this.data.countMin + ')'
        }];
      });
    }
  }

  ApplyData() {
    if (['Apply Costs', 'Account Test Mode', 'saveRoutingRuleNoConditions', 'SidPolicies',
        'saveRoutingRuleNoMCC', 'saveRoutingRuleNoClientId', 'removeVIPNumberReason',
      'addNVIPNumberReason', 'changeVIPNumberReason', 'deletingSMPPAccounts', 'changeTradingRules'].indexOf(this.type) > -1) {
      this.dialogRef.close('apply');
    }
    if (['SaveFilterConfirmation'].indexOf(this.type) > -1) {
      if (!this.stringValue) {
        return;
      } else {
        const model = {
          action: 'save',
          value: this.stringValue
        };
        this.dialogRef.close(model);
      }
    }
    if (this.type === 'RatesRecalculation') {
      this.dialogRef.close(this.recalcChoice);
    }
    if (['ClientXeroCheck', 'UpdateActivity', 'ProviderCostsUpdateActivity', 'UpdateRoutingProfileActivity',
         'routingRulesActivation'].indexOf(this.type) > -1) {
      this.dialogRef.close('update');
    }
    if (this.type === 'RemoveToggle') {
      this.dialogRef.close('remove');
    }
    if (this.type === 'CloseTab') {
      this.dialogRef.close('close');
    }
  }

  deleteData() {
    if (this.type === 'SMPP account') {
      this.clientAccountService._delete(this.clientAccountService.curVersion === 1 ? this.data.data_id : [this.data.data_id])
      .toPromise().then(response => {
        if (response && response.hasOwnProperty('status') && response.status === 200) {
          const ap = {
            comment: 'Delete SMPP connection' ,
            id: this.data.data_id,
            smpp_user: this.data.value
          };
          this.userAuditV2Service.createAuditRecord('SMPP Accounts', 'delete', JSON.stringify(ap));

          this.dialogRef.close('SMPP account was deleted successfully.');
        } else {
          this.dialogRef.close('Error deleting SMPP account!');
        }
      });
    }

/*     if (this.type === 'accountDelEMail') {

      this.subscription = this.accountEService._delete(this.data.data_id).subscribe(response => {
        if (response && response.hasOwnProperty('status') && response.status === 200) {
          const ap = {
            comment: 'Delete account E-Mail' ,
            id: this.data.data_id,
            value: this.data.value
          };
          this.userAuditV2Service.createAuditRecord('SMPP Accounts', 'delete', JSON.stringify(ap));

          this.dialogRef.close('E-Mail was deleted successfully.');
        } else {
          this.dialogRef.close('Error deleting account!');
        }
      });
    } */

    const onlyClose = ['DeletePolicy', 'DeletePolicies', 'DeleteFilter', 'DeleteFilters', 'DeleteTrafficBlockers', 'DeleteTrafficBlocker',
                       'DeleteStoplossTrigger', 'DeleteStoplossTriggers', 'DeleteRoutingRule', 'Provider SMPP account',
                       'deleteHLROverrides', 'deleteVIPListItem', 'DeleteRoutingRules', 'DeleteTradingRules',
                       'DeleteInvoiceVerificationReport', 'accountDelEMail', 'deletePrefixesItem',
                       'removeSelectedSIDs', 'removeALLSIDs', 'removeSelectedContentMasks', 'DeleteInvoiceSettings', 'deleteSetting',
                       'ProviderProfileRoutesDelete', 'deleteFilterConfirmation', 'deleteEmailSchedules',
                       'deleteExistingRuleBeforeSavingNew', 'removeActivePolicies', 'deleteDestPrefixes',
                       'RemoveDlrPolicy','removeDlrUndelMcc'];
    if (onlyClose.indexOf(this.type) > -1 ) {
      this.dialogRef.close('delete');
    }
  }

  ngOnDestroy() {

  }

}
